import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";

const UserMenu = ({ open, onClose }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };
  }, [open, onClose]);

  if (!open) return null;

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("username");

    window.location.href = "/login";
  };

  return createPortal(
    <div
      ref={menuRef}
      className="fixed top-16 right-4 w-52 bg-white text-black rounded shadow-xl z-[9999] border border-gray-200"
    >
      <Link
        className="block px-4 py-2 hover:bg-gray-100"
        to="/profile"
        onClick={onClose}
      >
        Профиль
      </Link>

      <Link
        className="block px-4 py-2 hover:bg-gray-100"
        to="/settings"
        onClick={onClose}
      >
        Настройки
      </Link>

      <Link
        className="block px-4 py-2 hover:bg-gray-100"
        to="/add-account"
        onClick={onClose}
      >
        Добавить аккаунт
      </Link>

      <Link
        className="block px-4 py-2 hover:bg-gray-100"
        to="/switch-account"
        onClick={onClose}
      >
        Сменить аккаунт
      </Link>

      <button
        type="button"
        onClick={handleLogout}
        className="w-full text-left px-4 py-2 hover:bg-gray-100 text-red-600 font-semibold"
      >
        Выйти
      </button>
    </div>,
    document.body
  );
};

export default UserMenu;